import toast, { Toast, ToastPosition } from 'react-hot-toast';

import CustomToast, { ICustomToastProps } from '@/components/common/CustomToast/CustomToast';

interface NotificationParams {
  title: ICustomToastProps['title'];
  text: ICustomToastProps['text'];
  type: ICustomToastProps['type'];
  duration?: number;
  position?: ToastPosition;
}

interface OpenParams extends NotificationParams { }

export class NotificationService {
  open(params: OpenParams) {
    const {
      text,
      title,
      duration = 5000,
      type = 'danger',
      position = 'bottom-left'
    } = params;

    this.renderNotification({ title, text, type, duration, position });
  }

  private renderNotification({ title, text, type, duration, position }: NotificationParams) {
    const toastFunc = (options: Toast) => (
      <CustomToast
        id={options.id}
        title={title}
        text={text}
        type={type}
      />
    );

    toast.custom(toastFunc, {
      position,
      duration,
    });
  }
}
